<template>
    <form class="form" @submit.prevent="$emit('submit')" @reset="$emit('reset')">
        <h4>{{$t('support.wizard.label_detail_stage')}}</h4>
        <ul class="list--radio" v-if="!isCustomProblem">
            <li v-for="option in options" :key="option" class="radio">
                <input type="radio" v-gen.id="option" v-gen.name="'title'" :value="option" v-model="selectedDetail"
                       required class="radio__rb">
                <label v-gen.for="option" class="radio__label">
                    <p class="radio__text">
                        {{$t('support.wizard.detail.header_' + option)}}
                        <span>
                            {{$t('support.wizard.detail.label_' + option)}}
                        </span>
                    </p>
                </label>
            </li>
            <li class="radio">
                <input type="radio" v-gen.id="'custom'" v-gen.name="'title'" value="custom" v-model="selectedDetail"
                       required class="radio__rb">
                <label v-gen.for="'custom'" class="radio__label">
                    <p>
                        {{$t('support.wizard.detail.header_custom')}}
                    </p>
                    <div class="row">
                        <div class="col-12">
                            <input type="text" v-model="customText" class="form__input--text transparent" :placeholder="$t('support.wizard.detail.label_header_custom')" :required="selectedDetail === 'custom'" >
                        </div>
                    </div>
                </label>
            </li>
        </ul>

        <div v-if="isCustomProblem" class="row">
            <div class="col-12 col-md-12 col-l-12 col-xl-12">
                 <textarea class="block__textarea form__input--textarea border_dark" v-model="customText" :placeholder="$t('support.wizard.detail.label_header_custom')" :required="selectedDetail === 'custom'" ></textarea>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-12 col-l-12 col-xl-12"> 
                <div class="form__buttons">
                    <button type="submit" class="button--cta" :disabled="!canSubmit">
                        {{$t('support.wizard.button_continue')}}
                    </button>
                    <button type="reset" class="button pull-left has-smaller-horizontal-padding">
                        {{$t('common.button.go_back')}}
                    </button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import {GET_TITLE, TITLE_CUSTOM, GET_DETAIL_OPTIONS, GET_DETAIL, SET_DETAIL, DETAIL_CUSTOM} from '../../store/modules/support_wizard';

    @Component
    export default class WizardDetailSelect extends Vue {
        customTextValue = (this.selectedDetail === DETAIL_CUSTOM) ? this.$store.getters[GET_DETAIL].text : '';
    
        created() {
            window.scrollTo(0,0);
        }
        get options() {
            return this.$store.getters[GET_DETAIL_OPTIONS];
        }

        get isCustomProblem() {
            return this.$store.getters[GET_TITLE].code === TITLE_CUSTOM;
        }

        get selectedDetail() {
            return this.$store.getters[GET_DETAIL].code;
        }

        set selectedDetail(code) {
            const text = (code === DETAIL_CUSTOM) ? this.customTextValue : this.getDetailText(code);
    
            // If the user selects a radio button for one of the problems listed, the text field underneath 'Anders, namelijk...' should be empty.
            if (code != DETAIL_CUSTOM){
                this.customTextValue = '';
            }
            this.$store.commit(SET_DETAIL, {code, text});
        }

        get customText() {
            return this.customTextValue;
        }

        set customText(value) {
            this.customTextValue = value;
            this.selectedDetail = DETAIL_CUSTOM;
        }

        getDetailText(code) {
            //return this.$t(`common.support.detail.${code}`);
            return this.$t(`support.wizard.detail.header_${code}`);
        }

        get canSubmit() {
            return !!this.selectedDetail;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/support/WizardDetailSelect.vue